import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'  // ← 引入路由守卫
import { getConfigKey } from "@/api/index";
Vue.config.productionTip = false
Vue.prototype.getConfigKey = getConfigKey
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')